module.exports = __webpack_public_path__ + "static/media/Similar-Issue-grey-icon.439af0b8.svg";